import * as React from 'react';
import translate from '../../../../locale/translate';

import ISettings from './ISettings';
import { IReportSettings } from '../../../../interfaces';

import { formatDate } from '../../util/StringUtil';
import { staticSeUrl } from '../../../../api/config';

interface ICustomer {
    companyName: string,
    cId: string,
}

interface IProps {
    customer: ICustomer,
    settings: ISettings,
    reportSettings: IReportSettings,
}

export default class Widget extends React.Component<IProps, void> {
    static propTypes = {
        customer: React.PropTypes.object.isRequired,
        settings: React.PropTypes.object.isRequired,
        reportSettings: React.PropTypes.object.isRequired,
    };

    renderImage(customer: ICustomer) {
        const logoUrl = `${staticSeUrl}/images/custom/${customer.cId}/report/cover.jpg`;

        return (
            <div>
                <img className="se-cover-image se-show-in-print" src={logoUrl} />

                <div className="jumbotron text-center se-show-in-editor">
                    <i className="fa fa-picture-o fa-5x" />
                    <p className="small muted">{translate.gettext("Cover logo placeholder")}</p>
                </div>
            </div>
        );
    }

    render() {
        const { customer, settings, reportSettings } = this.props;
        const { title } = settings;
        const { startMs, endMs } = reportSettings;

        return (
            <div>
                <div className="text-center se-cover se-pagebreak-after">
                    {this.renderImage(customer)}
                    <h1>{title}</h1>
                    <h3>{customer.companyName}</h3>
                    <p>{formatDate(startMs, settings.dateFormat)} - {formatDate(endMs, settings.dateFormat)}</p>
                    <a href="#endOfCover" className="se-cover-link se-show-in-print"><i className="fa fa-chevron-down" /></a>
                </div>
                <a id="endOfCover" />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/basic/title/Widget.tsx